import React, { useState, useEffect } from "react";
import { FaArrowUp } from "react-icons/fa";

const UpToTheTop: React.FC = () => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setVisible(window.scrollY > 200);
        };
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    return  (
        <button
            onClick={scrollToTop}
            className={`fixed bottom-8 right-8 h-12 w-12 flex items-center justify-center rounded-full bg-orange-500 text-white 
            shadow-lg cursor-pointer text-3xl z-[1000] transition-opacity duration-200
            ${visible ? "opacity-100" : "opacity-0 pointer-events-none"}`}
        >
            <FaArrowUp />
        </button>
    );
};

export default UpToTheTop;
